import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-3" data-id="element-46">
      {items.map((item, i) => <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-47">
          <button className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-48">
            <span className="font-semibold text-gray-800 pr-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-49">
              {item.question}
            </span>
            <ChevronDown className="w-5 h-5 flex-shrink-0 transition-transform duration-200" style={{
          color: '#1B8F4B',
          transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)'
        }} data-id="element-50" />
          </button>
          {openIndex === i && <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-3" data-id="element-51">
              {item.answer}
            </div>}
        </div>)}
    </div>;
}